import { LOGIN_URL, RESET_CODE_URL, VERIFY_URL } from '../../utils/Endpoints';
import { requests } from '.';

export function login(username: string, password: string) {
    return requests.post(LOGIN_URL, { username, password, isAdmin: true });
}

export async function verifyAccount(id: number, twoFactorToken: string) {
    return await requests.post(`${VERIFY_URL}/${id}`, { twoFactorToken });
}

export async function resetVerifyCode(email: string) {
    return await requests.put(`${RESET_CODE_URL}`, { email });
}
